function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useState } from 'react';
import { TextFormFieldRow } from '@rd-web-markets/shared/dist/util/form';
import { Loader } from '@rd-web-markets/shared/dist/util/Loader';
import { useTranslation } from 'react-i18next';
import IsNotSaved from '../IsNotSaved';
import partnershipsService from '../../../services/elster/partnerships.service';
import PartnershipParties from './PartnershipParties';
const TEXT_FIELDS = ['salutation', 'name_line_1', 'name_line_2', 'street', 'house_number', 'postal_code', 'city'];
const Partnerships = _ref => {
  let {
    elster
  } = _ref;
  const {
    t
  } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [isNotSaved, setIsNotSaved] = useState(false);
  const {
    partnership,
    setPartnership,
    updatePartnership
  } = partnershipsService.useCrud(elster === null || elster === void 0 ? void 0 : elster.id, setLoading);
  const saveData = useCallback(async body => {
    await updatePartnership({
      partnership: body
    });
    setIsNotSaved(false);
  }, [updatePartnership]);
  const updateLocal = useCallback((key, value) => {
    setPartnership(prev => _objectSpread(_objectSpread({}, prev || {}), {}, {
      [key]: value
    }));
    setIsNotSaved(true);
  }, [setPartnership]);
  if (loading && partnership == null) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", {
    className: "mb-3"
  }, t('additional_information_for_partnership')), /*#__PURE__*/React.createElement("p", {
    className: "fw-bold"
  }, t('additional_information_for_partnership_subtitle')), TEXT_FIELDS.map(fieldName => /*#__PURE__*/React.createElement(TextFormFieldRow, {
    key: fieldName,
    fieldName: fieldName,
    label: fieldName,
    value: (partnership === null || partnership === void 0 ? void 0 : partnership[fieldName]) || '',
    onChange: e => updateLocal(fieldName, e.target.value),
    labelColSpan: 6,
    dataTestId: "partnerships_".concat(fieldName)
  })), /*#__PURE__*/React.createElement(IsNotSaved, {
    isNotSaved: isNotSaved,
    save: saveData,
    paramsForUpdate: [partnership],
    loading: loading
  }), partnership != null && /*#__PURE__*/React.createElement(PartnershipParties, {
    partnership: partnership,
    setPartnership: setPartnership,
    setLoading: setLoading
  }));
};
export default Partnerships;